import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/liquidaciones-configuraciones-incidencias';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Liquidaciones Configuraciones Incidencias
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLiquidacionesConfiguracionesIncidencias = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Liquidacion Configuracion Incidencia
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLiquidacionConfiguracionIncidencia = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Liquidacion Configuracion Incidencia
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLiquidacionConfiguracionIncidencia = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Liquidacion Configuracion Incidencia
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLiquidacionConfiguracionIncidencia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Configuracion Incidencia
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionConfiguracionIncidencia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
